//@config
//@config
export default {
  center_des_avocats: {
    inquiry_list: "v1/inquiry",
    importInquiry: "v1/import-inquiry",
    parvandehInquiries: "v1/parvandeh-inquiries",
    changeInquiryStatus: "v1/parvandeh/{0}/inquiry",
    parvandehInquiry: "v1/parvandeh/{0}/inquiries",
    parvandehInquiryId: "v1/parvandeh/{0}/inquiries/{1}",
  },
};
